import { Component, OnInit, HostListener } from '@angular/core';

import { DocPart } from '../../../models/doc-part';

import { DocPartService } from '../../../services/documents/doc-part.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-doc-part-index',
  templateUrl: './doc-part-index.component.html',
  styleUrls: ['./doc-part-index.component.scss'],
})
export class DocPartIndexComponent implements OnInit {
  count: number = 0;

  docParts: Array<DocPart> = [];

  loading: boolean = true;

  loadingErred: boolean = false;

  /**
   * Indicates if search is being performed
   * @type {boolean}
   */
  searching: boolean = false;

  searchOptions: any = {
    per_page: 20,
  };

  searchParams: any = {
    page: 1,
    per_page: 20,
  };

  /**
   * Indicates if sidebar is maximized on large screens
   * @type {boolean}
   */
  sidebarMaximized: boolean = false;

  /**
   * Inidicates if sidebar is open on small screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  constructor(private docPartService: DocPartService, private notyService: NotyService) {
    this.loading = true;
  }

  ngOnInit() {
    this.loading = true;
    this.docPartService
      .searchOptions()
      .then((response_json) => {
        this.loadingErred = false;
        this.searchOptions = response_json.search_options;
        this.searchParams.per_page = this.searchOptions.per_page;
        this.load();
      })
      .catch(() => {
        this.notyService.notify('Error loading search sidebar', 'error');
        this.loading = false;
        this.loadingErred = true;
      });
  }

  clearSearch() {
    this.searchParams = {
      page: 1,
      per_page: this.searchOptions.per_page,
    };
  }

  load() {
    this.loading = true;
    this.search();
  }

  /**
   * Page changed
   * @param {any} $event Page change event with new page number
   */
  pageChanged($event: any) {
    this.searchParams.page = $event.page;
    this.search();
  }

  /**
   * Process search request
   */
  search() {
    this.docPartService
      .index(this.searchParams)
      .then((response_json) => {
        this.loading = false;
        this.loadingErred = false;
        this.docParts = response_json.doc_parts;
        this.count = response_json.count;
      })
      .catch(() => {
        this.notyService.notify('Error loading doc parts', 'error');
        this.loading = false;
        this.loadingErred = true;
      });
  }

  // Positioning events and methods
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
    }
  }
}
